/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgExcelLogoColor = (props)=>/*#__PURE__*/ React.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M11 2.001V3.5h3l1 .5v4L9.469 9 4 8V1.875c0-.232.108-.455.299-.619C4.49 1.092 4.75 1 5.021 1L10 1.001l1 1Z",
        fill: "#21A366"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M15 4V1.875A.878.878 0 0 0 14.125 1H10v3h5Z",
        fill: "#33C481"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M15 8H4v4l5.5 1 5.5-1V8Z",
        fill: "#107C41"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M4 12v2.125a.878.878 0 0 0 .875.875h9.25a.875.875 0 0 0 .875-.875V12H4Z",
        fill: "#185C37"
    }), /*#__PURE__*/ React.createElement("path", {
        opacity: 0.5,
        d: "M9.2 5H4v8h5.2a.8.8 0 0 0 .8-.8V5.8a.8.8 0 0 0-.8-.8Z",
        fill: "#000"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.2 4H1.8a.8.8 0 0 0-.8.8v6.4a.8.8 0 0 0 .8.8h6.4a.8.8 0 0 0 .8-.8V4.8a.8.8 0 0 0-.8-.8Z",
        fill: "#107C41"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M4.034 5.615H2.838l1.42 2.393L2.802 10.4h1.196L5 8.677 6.012 10.4H7.2L5.732 8.008l1.442-2.393H5.981L5 7.381l-.966-1.766Z",
        fill: "#fff"
    }));
export default SvgExcelLogoColor;
